// extracted by mini-css-extract-plugin
module.exports = {"container":"NilGrowth_container__dj8cj","graphHeader":"NilGrowth_graphHeader__pcg0w","graphTitle":"NilGrowth_graphTitle__Cidm8"};